import { FIELD_CLS, LABEL_CLS } from '../../styles/tokens';

interface Props {
  weather: string; setWeather: (v: string) => void;
  wellCondition: string; setWellCondition: (v: string) => void;
  odor: string; setOdor: (v: string) => void;
  sheen: string; setSheen: (v: string) => void;
  observations: string; setObservations: (v: string) => void;
  notes: string; setNotes: (v: string) => void;
}

/** Observations step — narrative field-tech notes the lab and PM will read. */
export function ObservationsStep({
  weather, setWeather,
  wellCondition, setWellCondition,
  odor, setOdor,
  sheen, setSheen,
  observations, setObservations,
  notes, setNotes,
}: Props) {
  return (
    <div className="space-y-4">
      <header>
        <h2 className="text-lg font-semibold text-mono-100">Observations</h2>
        <p className="text-xs text-mono-400 mt-0.5">
          Anything the lab or PM should know. All fields optional.
        </p>
      </header>

      <div className="grid grid-cols-2 gap-3">
        <label className="block">
          <span className={LABEL_CLS}>Weather</span>
          <input type="text" className={`${FIELD_CLS} mt-1`} value={weather} onChange={(e) => setWeather(e.target.value)} placeholder="e.g. sunny, 85 °F" />
        </label>
        <label className="block">
          <span className={LABEL_CLS}>Well condition</span>
          <input type="text" className={`${FIELD_CLS} mt-1`} value={wellCondition} onChange={(e) => setWellCondition(e.target.value)} placeholder="cap intact / damaged / …" />
        </label>
        <label className="block">
          <span className={LABEL_CLS}>Odor</span>
          <input type="text" className={`${FIELD_CLS} mt-1`} value={odor} onChange={(e) => setOdor(e.target.value)} placeholder="hydrocarbon, sulfide, none" />
        </label>
        <label className="block">
          <span className={LABEL_CLS}>Sheen</span>
          <input type="text" className={`${FIELD_CLS} mt-1`} value={sheen} onChange={(e) => setSheen(e.target.value)} placeholder="none / faint / heavy" />
        </label>
      </div>

      <label className="block">
        <span className={LABEL_CLS}>Field notes</span>
        <textarea
          rows={3}
          className={`${FIELD_CLS} mt-1 min-h-[88px]`}
          value={observations}
          onChange={(e) => setObservations(e.target.value)}
          placeholder="Anything noteworthy about the well, the conditions, the equipment…"
        />
      </label>

      <label className="block">
        <span className={LABEL_CLS}>Quick notes <span className="text-mono-600 normal-case tracking-normal">(short, surfaces on reports)</span></span>
        <input
          type="text"
          className={`${FIELD_CLS} mt-1`}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="One-line summary"
        />
      </label>
    </div>
  );
}
